var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1076.9 886.4",
    viewBox: "0 0 1076.9 886.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 538.4,
    cy: 440,
    r: 424.1,
    stroke: "#000",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m538.4 15.8v848.3l-424.1-424.1h848.3z",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505 216.1v23.3l-275.5 422.7h-49.2v-23.3l276.1-422.6zm-318.1 118.5 5.3-118.5h290.2v33.3h-266.9l36.6-33.3-25.3 118.5zm332.7 209-5.3 118.4h-310.8v-33.3h287.5l-36.6 33.3 25.3-118.5h39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.9 242.7v-26.6h93.1v36.6h-6.7zm99.8 382.7 86.5 10v26.6h-186.3v-26.6l86.5-10zm-36.6-203c0-68.5 0-137.8-2-206.3h63.9c-2 67.2-2 136.4-2 206.3v25.3c0 76.5 0 145.7 2 214.3h-63.9c2-67.2 2-136.4 2-206.3zm214.3-206.3 29.9 33.3h-214.3v-33.3h237.6l4.7 118.5h-37.3zm-28.6 233.7h-155.8v-30.6h155.7v30.6zm-21.3-24 10-70.5h29.9v164.4h-29.9l-10-73.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m309.5 440h64.3l-101.8 157-39.2-39.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m303.3 629 34.6 33.1h176.3l5.3-118.5h-39.9l-18.3 85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m625.3 438.9v-189.2l-62.5-6.9v-26.6h172.6l34.9 32.8-83.6.6-.6 169.6h105.2l9-63.9h30v83.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m737.9 216.2 33.4 33.3h-.4l-35.3-33.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m771.2 249.5-84.4.1 83.6-.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m373.9 440.6-101.5 156.8-.4-.4 101.9-157h.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m374.5 440-102.1 157.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e9441bcf1b073c5f1a00c9fae95587b.svg";
export { ForwardRef as ReactComponent };